const PT = require("prop-types");
const _ = require("lodash");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const OpsUser = require("../core/vault/OpsUser");
const PasswordSetup = require("./PasswordSetup");
const UnderlineView = require("./UnderlineView");
const CopyTable = require("./data/CopyTable");
const ErrorCopy = require("../core/util/CopyTable");

const styles = require("./styles/PageAccountSetup.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageAccountSetup",

		propTypes: {
			user: PT.object.isRequired,
			code: PT.string,
			email: PT.string,
			isMultiple: PT.number,
			type: PT.string,
			requireLoggedIn: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			setupAccountPasswordFail: function(error) {
				this.setState({
					backendErrorType: error,
				});
			},
		},

		getInitialState: function() {
			return {
				backendErrorType: null,
			};
		},

		startLogin: function() {
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		renderErrorEl: function(errorText, shouldShow) {
			const errorClass = shouldShow
				? styles.errorTextCenter
				: styles.errorTextHidden;
			return <div className={errorClass}>{"* " + errorText}</div>;
		},

		render: function() {
			const {code, email, isMultiple, type, user, requireLoggedIn} = this.props;

			const underlineText = _.capitalize(type);
			const isParent = type === "parent";
			const isLoggedIn = OpsUser.isLoggedIn(user);

			// By the time we get to this view, it is not possible to be
			// logged in AND logged in as a different user than the
			// this.props.email.

			const subtitleIntroEl = isLoggedIn ? null : (
				<div className={styles.subtitleText}>Create your</div>
			);

			const backendError = this.renderErrorEl(
				ErrorCopy.forAccountSetupError(this.state.backendErrorType, type),
				this.state.backendErrorType
			);

			let mainContent;
			if (!isLoggedIn && requireLoggedIn) {
				mainContent = (
					<div className={styles.across}>
						<div className={styles.formContainer}>
							<div className={styles.form}>
								<div className={styles.why}>
									You must sign into your {email} AoPS account to complete
									setup.
								</div>
								<div className={styles.signinLink} onClick={this.startLogin}>
									Click here to sign in.
								</div>
								<div className={styles.italText}>
									{CopyTable.getSharedAccountCopy(email)}
								</div>
							</div>
						</div>
					</div>
				);
			} else {
				let topCopy, bottomCopy;
				if (type === "parent") {
					topCopy = CopyTable.getCreateAccountCopy(!requireLoggedIn, user);
					bottomCopy = CopyTable.getPurchaseOrderAccountSetupCopy(isMultiple);
				} else if (isLoggedIn) {
					topCopy = `Click Accept Invite below to accept this Beast Academy Online staff invitation with your ${email} account.`;
				} else {
					topCopy = `Finish setting up your staff account below.`;
					bottomCopy = `Click continue to finish setting up your account.`;
				}
				mainContent = (
					<PasswordSetup
						code={code}
						email={email}
						isMultiple={isMultiple}
						showCoppa={isParent}
						showPassword={!isLoggedIn}
						type={type}
						topCopy={topCopy}
						bottomCopy={bottomCopy}
						backendError={backendError}
					/>
				);
			}

			return (
				<div className={styles.main}>
					<div className={styles.title}>
						<span>
							Welcome to <br className={styles.titleBreak} />
							BA Online
						</span>
					</div>
					<div className={styles.subtitle}>
						{subtitleIntroEl}
						<UnderlineView
							text={`${underlineText} Account:`}
							className={styles.subtitleUnderline}
						/>
					</div>
					{mainContent}
				</div>
			);
		},
	})
);
